var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXlm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.002 12.687a5.44 5.44 0 0 1 .627-3.3a5.16 5.16 0 0 1 1.825-1.922a4.9 4.9 0 0 1 2.5-.722a4.9 4.9 0 0 1 2.513.668l1.154-.613A5.95 5.95 0 0 0 9.2 6.273a6.27 6.27 0 0 0-2.456 2.37a6.64 6.64 0 0 0-.89 3.848a1.2 1.2 0 0 1-.14.661a1.14 1.14 0 0 1-.469.47l-.53.28v1.314l14.572-7.743V6.16zm12.284-3.9L7.783 14.895l-3.069 1.631v1.312l12.287-6.529q.043.345.043.692a5.44 5.44 0 0 1-.67 2.617a5.16 5.16 0 0 1-1.827 1.923a4.9 4.9 0 0 1-2.503.72a4.9 4.9 0 0 1-2.516-.672l-.061.034l-1.089.579a5.95 5.95 0 0 0 6.42.525a6.27 6.27 0 0 0 2.458-2.368a6.64 6.64 0 0 0 .891-3.852a1.2 1.2 0 0 1 .14-.66c.107-.2.27-.363.469-.47l.53-.282z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlm);
export default __webpack_public_path__ + "static/media/xlm.9b121bd4f096e4afa69a8241b6d50689.svg";
export { ForwardRef as ReactComponent };